export default function () {
  return {
    financialSummaryByYearCustomer: {},
    isLoadingFinancialSummary: false,
  };
}
